export default __webpack_public_path__ + "static/flammable_b.0301035a57fdd5fddb401768a79dad07.svg";